/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminProfile,
  AdminSubscriberBenefit,
  AdminV1OrganizationsProfilesBenefitsListParams,
  AdminV1OrganizationsProfilesListParams,
  AdminV1OrganizationsProfilesSplitSharedAccountCreateBody,
  BulkTeamChange,
  BulkTeamChangeResponse,
  BulkUserArchiveResponse,
  BulkUserDelete,
  EnsurePayabliCustomerResponse,
  EnsureSendbirdUserResponse,
  PaginatedAdminProfileList,
  PatchedAdminProfile
} from '.././model';

import adminV1OrganizationsProfilesListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesBenefitsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesEnsurePayabliCustomerCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesEnsureSendbirdUserCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesSplitSharedAccountCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesTeamsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesTeamsDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesBulkActionsChangeTeamCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesBulkActionsDeleteUsersCreateMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Custom list method with comprehensive performance logging.
 * @summary Custom list method with comprehensive performance logging.
 */
export const adminV1OrganizationsProfilesList = (
    organizationId: number,
    params?: AdminV1OrganizationsProfilesListParams,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesListMutator<PaginatedAdminProfileList>>,) => {
      return adminV1OrganizationsProfilesListMutator<PaginatedAdminProfileList>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsProfilesCreate = (
    organizationId: number,
    adminProfile: NonReadonly<AdminProfile>,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesCreateMutator<AdminProfile>>,) => {
      return adminV1OrganizationsProfilesCreateMutator<AdminProfile>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminProfile
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsProfilesRetrieve = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesRetrieveMutator<AdminProfile>>,) => {
      return adminV1OrganizationsProfilesRetrieveMutator<AdminProfile>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsProfilesUpdate = (
    organizationId: number,
    id: number,
    adminProfile: NonReadonly<AdminProfile>,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesUpdateMutator<AdminProfile>>,) => {
      return adminV1OrganizationsProfilesUpdateMutator<AdminProfile>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminProfile
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsProfilesPartialUpdate = (
    organizationId: number,
    id: number,
    patchedAdminProfile: NonReadonly<PatchedAdminProfile>,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesPartialUpdateMutator<AdminProfile>>,) => {
      return adminV1OrganizationsProfilesPartialUpdateMutator<AdminProfile>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminProfile
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsProfilesDestroy = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesDestroyMutator<void>>,) => {
      return adminV1OrganizationsProfilesDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Get subscriber benefits (from memberships and registrations) for a specific profile. If the profile is a contact (no team), returns benefits for all associated player profiles. Pass ?usable=true to filter to only benefits that can be applied to bookings. Returns a direct array (not paginated).
 * @summary List benefits for a profile
 */
export const adminV1OrganizationsProfilesBenefitsList = (
    organizationId: number,
    id: number,
    params?: AdminV1OrganizationsProfilesBenefitsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesBenefitsListMutator<AdminSubscriberBenefit[]>>,) => {
      return adminV1OrganizationsProfilesBenefitsListMutator<AdminSubscriberBenefit[]>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/benefits/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Creates the billing profile and Payabli customer for this profile if missing. A profile that already has a Payabli customer is left untouched (never resynced). Staff only.
 * @summary Ensure a Payabli customer exists for this profile
 */
export const adminV1OrganizationsProfilesEnsurePayabliCustomerCreate = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesEnsurePayabliCustomerCreateMutator<EnsurePayabliCustomerResponse>>,) => {
      return adminV1OrganizationsProfilesEnsurePayabliCustomerCreateMutator<EnsurePayabliCustomerResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/ensure-payabli-customer/`, method: 'POST'
    },
      options);
    }
  /**
 * Creates the Sendbird user for this profile if one doesn't exist yet. A profile that already has a Sendbird user is left untouched (never resynced). Staff only.
 * @summary Ensure a Sendbird user exists for this profile
 */
export const adminV1OrganizationsProfilesEnsureSendbirdUserCreate = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesEnsureSendbirdUserCreateMutator<EnsureSendbirdUserResponse>>,) => {
      return adminV1OrganizationsProfilesEnsureSendbirdUserCreateMutator<EnsureSendbirdUserResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/ensure-sendbird-user/`, method: 'POST'
    },
      options);
    }
  /**
 * Splits a shared account where a parent and player use the same login. Creates a new User for the player with the provided email, and creates a new parent-only Profile on the original User.
 * @summary Split shared parent/player account
 */
export const adminV1OrganizationsProfilesSplitSharedAccountCreate = (
    organizationId: number,
    id: number,
    adminV1OrganizationsProfilesSplitSharedAccountCreateBody: AdminV1OrganizationsProfilesSplitSharedAccountCreateBody,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesSplitSharedAccountCreateMutator<AdminProfile>>,) => {
      return adminV1OrganizationsProfilesSplitSharedAccountCreateMutator<AdminProfile>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/split-shared-account/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminV1OrganizationsProfilesSplitSharedAccountCreateBody
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsProfilesTeamsCreate = (
    organizationId: number,
    id: number,
    teamId: number,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesTeamsCreateMutator<AdminProfile>>,) => {
      return adminV1OrganizationsProfilesTeamsCreateMutator<AdminProfile>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/teams/${teamId}/`, method: 'POST'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsProfilesTeamsDestroy = (
    organizationId: number,
    id: number,
    teamId: number,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesTeamsDestroyMutator<void>>,) => {
      return adminV1OrganizationsProfilesTeamsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${id}/teams/${teamId}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Change team assignment for multiple profiles in bulk. Returns detailed results including successful changes and failures. Requires admin access to the organization.
 * @summary Change team assignment for multiple profiles in bulk. Returns detailed results including successful changes and failures. Requires admin access to the organization.
 */
export const adminV1OrganizationsProfilesBulkActionsChangeTeamCreate = (
    organizationId: number,
    bulkTeamChange: BulkTeamChange,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesBulkActionsChangeTeamCreateMutator<BulkTeamChangeResponse>>,) => {
      return adminV1OrganizationsProfilesBulkActionsChangeTeamCreateMutator<BulkTeamChangeResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/bulk-actions/change-team/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkTeamChange
    },
      options);
    }
  /**
 * Delete multiple users in bulk by their profile IDs. Returns detailed results including successful deletions and failures. Requires admin access to the organization. Users cannot delete their own account through this endpoint.
 * @summary Delete multiple users in bulk by their profile IDs. Returns detailed results including successful deletions and failures. Requires admin access to the organization. Users cannot delete their own account through this endpoint.
 */
export const adminV1OrganizationsProfilesBulkActionsDeleteUsersCreate = (
    organizationId: number,
    bulkUserDelete: BulkUserDelete,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesBulkActionsDeleteUsersCreateMutator<BulkUserArchiveResponse>>,) => {
      return adminV1OrganizationsProfilesBulkActionsDeleteUsersCreateMutator<BulkUserArchiveResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/bulk-actions/delete-users/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkUserDelete
    },
      options);
    }
  export type AdminV1OrganizationsProfilesListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesList>>>
export type AdminV1OrganizationsProfilesCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesCreate>>>
export type AdminV1OrganizationsProfilesRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesRetrieve>>>
export type AdminV1OrganizationsProfilesUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesUpdate>>>
export type AdminV1OrganizationsProfilesPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesPartialUpdate>>>
export type AdminV1OrganizationsProfilesDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesDestroy>>>
export type AdminV1OrganizationsProfilesBenefitsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesBenefitsList>>>
export type AdminV1OrganizationsProfilesEnsurePayabliCustomerCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesEnsurePayabliCustomerCreate>>>
export type AdminV1OrganizationsProfilesEnsureSendbirdUserCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesEnsureSendbirdUserCreate>>>
export type AdminV1OrganizationsProfilesSplitSharedAccountCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesSplitSharedAccountCreate>>>
export type AdminV1OrganizationsProfilesTeamsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesTeamsCreate>>>
export type AdminV1OrganizationsProfilesTeamsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesTeamsDestroy>>>
export type AdminV1OrganizationsProfilesBulkActionsChangeTeamCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesBulkActionsChangeTeamCreate>>>
export type AdminV1OrganizationsProfilesBulkActionsDeleteUsersCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesBulkActionsDeleteUsersCreate>>>
